class SwiperMobileSlider extends HTMLElement {
  constructor(){
    super();
    const breakpoint = window.matchMedia( '(min-width:811px)' );
    let mySwiper; 
    const breakpointChecker = function() {
      if ( breakpoint.matches === true ) {
        if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
        return;
        } else if ( breakpoint.matches === false ) {
          return enableSwiper();
        }
    };
    const enableSwiper = function() {
      mySwiper = new Swiper ('.js-swiper-container-collection', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: false,
        centeredSlides: false,
      });
    }; 
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  }
}
customElements.define("collection-blocks-slider", SwiperMobileSlider);